import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { AnimatePresence } from "framer-motion"
import Measure from 'react-measure'
import { sub, format } from 'date-fns'

import { Button, ListTile, Animation } from 'components'
import { PrioritySelector, DeleteDialogue, ItemModal, TagInput, ScheduleInput, AlertInput, SectionSelector } from 'features'
import ContextMenu from '../ContextMenu'
import {
    FaExpandAlt, FaFlag, FaCalendarDay, FaTags, FaTrashAlt, FaAngleLeft, 
    FaEdit, FaBell, FaTasks, FaCalendarPlus, FaCalendarMinus, FaExchangeAlt
} from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import { Focus, Alert } from 'schema'
import { itemContext } from 'context'
import moment from 'moment-timezone'

const Line = styled.hr`
    border-color: var(--secondary-accent2-color);
`;

// const Title = styled.div`
//     grid-template-columns: 2rem auto 2rem;
//     display: grid;
//     justify-items: center;
//     align-items: center;
//     margin-bottom: 0.3rem;
//     font-weight: bolder;
//     font-size: 0.9rem;
// `

const Title = styled.div`
    grid-template-columns: 2rem auto 2rem;
    display: grid;
    justify-items: center;
    align-items: center;
    margin-bottom: 0.3rem;

    font-weight: bolder;
    font-size: 0.7rem;
    /* padding: 0.25rem 0 0.5rem 0.25rem; */
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

class ItemMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            boundingRect: null,
            unfocus: true
        }
        this.containerRef = React.createRef()
        this.exitButtonStyle = {
            backgroundColor:'var(--secondary-color)',
            margin:'0',
            boxShadowColor: 'transparent',
            padding: '0.4rem',
            color: 'var(--secondary-accent-color)'
        }
        console.log(this.props.item)
    }

    changePriority = (val) => {
        let updatedItem = {...this.props.item}
        updatedItem['priority'] = val
        this.props.updateItem(updatedItem, this.props.data, this.props.uid, this.props.sessionId)
    }

    openItem = () => {
        this.props.setModal(<ItemModal itemID={this.props.item['itemID']} item={this.props.item} id={this.props.item.itemID}/>, `${this.props.item.itemID}_ItemModal`)
        this.props.setInput(null,null)
        this.props.closeHandler()
    }

    editItem = () => {
        this.props.closeHandler()
        if(this.props.item.itemID !== this.props.inputID){
            this.props.setInput(`ItemInput_${this.props.item.itemID}`)
        } else {
            this.props.setInput(null)
        }
    }

    selectOption = (option, key) => {
        this.setState({
            content: option
        })
        // console.log(option, key)
        key && this.props.setInput(key)
    }

    setScheduleToday = () => {
        // const today = new Date().setHours(0,0,0,0)
        const today = moment().tz(this.props.user['timezone']).set({hour: 0, minute: 0, second: 0})
        const schedule = {
            startDate: today,
            endDate: today,
            startTime: null,
            endTime: null,
        }
        this.setSchedule(schedule)
        this.props.closeHandler()
    }

    removeSchedule = () => {
        const schedule = {
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null,
        }
        this.setSchedule(schedule)
        this.props.closeHandler()
    }

    setSchedule = (schedule) => {
        let updatedItem = {...this.props.item}
        const hasSchedule = schedule['startDate'] || schedule['endDate'] || schedule['startTime'] || schedule['endTime'] ? true : false
        const refDate = hasSchedule && moment(schedule['startTime'] || schedule['endTime'] || schedule['startDate'] || schedule['endDate']).tz(this.props.user['timezone'])

        // Add schedule
        updatedItem['start_date'] = schedule['startDate']
        updatedItem['end_date'] = schedule['endDate']
        updatedItem['start_time'] = schedule['startTime']
        updatedItem['end_time'] = schedule['endTime']
        console.log({schedule, refDate})

        let updatedAlerts = []
        if(hasSchedule & updatedItem['alerts'].length > 0){
            // Update existing alerts
            Object.values(updatedItem['alerts']).map(alertID => {
                let updatedAlert = this.props.data['alerts'][alertID]
                let option = {}
                option[updatedAlert['reference']['metric']] = updatedAlert['reference']['value']
                const date = refDate.subtract(option)
                const type = date.hours() === 0 & date.minutes() === 0 & date.seconds() === 0 & date.milliseconds() === 0 ? 'day' : 'time'
                const subtitle = date.format(type === 'day' ? 'ddd, MMM D Y' : 'ddd, MMM D Y (h:mma)')

                updatedAlert['date'] = date
                updatedAlert['subtitle'] = subtitle
                updatedAlerts.push(updatedAlert)
            })
        } else if(hasSchedule & updatedItem['alerts'].length === 0) {
            // Create alert
            const date = refDate
            const type = date.hours() === 0 & date.minutes() === 0 & date.seconds() === 0 & date.milliseconds() === 0 ? 'day' : 'time'
            const title = this.props.item.getPlainText()
            const subtitle = date.format(type === 'day' ? 'ddd, MMM D Y' : 'ddd, MMM D Y (h:mma)')

            let newAlert = new Alert({
                userID: this.props.uid,
                title: title,
                subtitle: subtitle,
                date: date,
                secID: {id: this.props.item['itemID'], relation: 'item'}
            })
            updatedAlerts.push(newAlert)
        } else if (!hasSchedule & updatedItem['alerts'].length > 0){
            // Remove existing schedule
            Object.values(updatedItem['alerts']).map(alertID => {
                delete updatedAlerts[alertID]
            })
        }
        console.log({updatedAlerts})
        this.props.updateItemSchedule(updatedAlerts, updatedItem, this.props.data, this.props.uid, this.props.sessionId)
    }

    _setAlerts = (alerts) => {
        const title = this.props.item.getPlainText()
        const secID = {id: this.props.item['itemID'], relation: 'item'}
        const refDate = this.props.item.start_time || this.props.item.end_time || this.props.item.start_date || this.props.item.end_date
        
        let updatedAlerts = []
        alerts.map(alert => {
            let updatedAlert = alert
            updatedAlert['userID'] = this.props.uid
            updatedAlert['title'] = title
            updatedAlert['secID'] = secID
            let option = {}
            option[alert['reference']['metric']] = alert['reference']['value']
            const date = sub(new Date(refDate), option)
            const type = date.getHours() === 0 & date.getMinutes() === 0 & date.getSeconds() === 0 & date.getMilliseconds() === 0 ? 'day' : 'time'
            const subtitle = format(date, type === 'day' ? 'eee, MMM d yyyy' : 'eee, MMM d yyy (h:mm aaaa)')
            updatedAlert['subtitle'] = subtitle
            updatedAlerts.push(updatedAlert)
        })
        this.props.updateItemSchedule(updatedAlerts, this.props.item, this.props.data, this.props.uid, this.props.sessionId)
    }

    setAlerts = (alerts) => {
        console.log('[ItemOptions] setAlerts', alerts)
        this.props.updateItemSchedule(alerts, this.props.item, this.props.data, this.props.uid, this.props.sessionId)
    }

    deleteHandler = () => {
        this.props.deleteItem(this.props.item, this.props.data, this.props.uid)
        this.props.closeHandler()
        // this.props.setModal(null,null)
    }

    moveHandler = (pageID, sectionID) => {
        const position = this.props.data['sections'][sectionID]['items']['INCOMPLETE'].length
        // console.log('[Move item]', {pageID: pageID, sectionID: sectionID, position: position, section: this.props.data['sections'][sectionID]})
        this.props.shiftItem(this.props.data, this.props.item, [], position, sectionID, pageID, this.props.uid, this.props.sessionId)
        this.props.closeHandler()

    }

    statusHandler = () => {
        this.props.updateItemStatus(this.props.item, this.props.data, this.props.uid, this.props.sessionId)
        this.props.onClose && this.props.onClose()
        this.props.closeHandler && this.props.closeHandler()
    }

    render(){
        let content = null
        let item = this.props.item
        const incomplete = item['status'] === itemContext.STATUS.INCOMPLETE
        // const schedule = {
        //     start_date: item.start_date ? new Date(item.start_date) : null,
        //     end_date: item.end_date ? new Date(item.end_date) : null, 
        //     start_time: item.start_time ? new Date(item.start_time) : null,
        //     end_time: item.end_time ? new Date(item.end_time) : null
        // }

        const schedule = {
            start_date: item.start_date ? moment(item.start_date) : null,
            end_date: item.end_date ? moment(item.end_date) : null, 
            start_time: item.start_time ? moment(item.start_time) : null,
            end_time: item.end_time ? moment(item.end_time) : null
        }

        // Alert params
        const hasSchedule = item.start_date || item.end_date || item.start_time || item.end_time ? true : false
        const alert = this.props.item.getAlert(this.props.user['timezone'])  
        
        // Focus
        const date = format(new Date(), 'LLL d Y')
        const focus = !this.props.data['focus'] ? new Focus({date: date})
                    : !this.props.data['focus'][date] ? new Focus({date: date})
                    : this.props.data['focus'][date]
        const inFocus = Object.values(focus['items']).includes(this.props.item['itemID'])
        switch ( this.state.content ) {
            case 'priority':
                content = 
                <AnimatePresence>
                    <Animation key='priority' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <Title>
                            <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.exitButtonStyle}/>
                            <div>Priority</div>
                        </Title>
                        <PrioritySelector type='content' onSelect={this.changePriority} closeHandler={() => {this.props.closeHandler()}} styles={{boxShadow: 'transparent', border: '0px solid transparent'}}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'tags':
                content = 
                <AnimatePresence>
                    <Animation key='tags' animation='slideLeft' boundingRect={this.state.boundingRect} onAnimationComplete={() => {this.setState({unfocus: false})}}>
                        <Title>
                            <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.exitButtonStyle}/>
                            <div>Tags</div>
                        </Title>
                        <TagInput item={this.props.item} inline unfocus={this.state.unfocus}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'schedule':
                content = 
                <AnimatePresence>
                    <Animation key='schedule' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <Title>
                            <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.exitButtonStyle}/>
                            <div>Schedule</div>
                        </Title>
                        <ScheduleInput inline onSubmit={this.setSchedule} closeHandler={() => {this.props.closeHandler()}} schedule={schedule}/>
                    </Animation>
                </AnimatePresence>
                break
            
            case 'unschedule':
                content = 
                <AnimatePresence>
                    <Animation key='schedule' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <div key='placeholder'></div>
                        <Animation key='main' animation='slideLeft' boundingRect={this.state.boundingRect}>
                            <DeleteDialogue submitText='Unschedule'
                                onDelete={this.removeSchedule}
                                closeHandler={() => {this.setState({content: 'main'})}}/>
                        </Animation>
                    </Animation>
                </AnimatePresence>
                break

            case 'delete':
                content = 
                <AnimatePresence key='delete'>
                    <div key='placeholder'></div>
                    <Animation key='main' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <DeleteDialogue 
                            onDelete={this.deleteHandler}
                            closeHandler={() => {this.setState({content: 'main'})}}/>
                    </Animation>
                </AnimatePresence>
                break
            case 'move':
                content = 
                <AnimatePresence key='delete'>
                    <Title>
                        <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.exitButtonStyle}/>
                        <div>Shift item</div>
                    </Title>
                    <Animation key='main' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <SectionSelector sectionID={this.props.item['sectionID']} pageID={this.props.item['pageID']}
                            onSelect={this.moveHandler} onClose={() => {this.setState({content: 'main'})}}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'alerts':
                // const alerts = this.props.item['alerts'] && Object.values(this.props.item['alerts']).map(alert => alert.date)
                const alerts = Object.values(this.props.item['alerts']).length > 0 && Object.values(this.props.item['alerts']).map(alertID => (this.props.data['alerts'][alertID]))
                content = 
                <AnimatePresence key='alerts'>
                    <div></div>
                    <Animation key='alertOption' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <AlertInput inline date={alert.date} timezone={this.props.user['timezone']}
                            userID={this.props.user['uid']} secID={{id: this.props.item['itemID'], relation: 'item'}}
                            title={this.props.item.getPlainText()}
                            onClose={() => {this.setState({content: 'main'})}} onSelect={this.setAlerts}
                            type={alert.type} 
                            alerts={alerts}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'main':
                content = 
                this.props.type === 'calendar' ? 
                <AnimatePresence key='main'>
                    <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                        <ListTile text='Open' icon={<FaExpandAlt/>} onSelect={this.openItem}/>
                        <ListTile text='Priority' icon={<FaFlag/>} onSelect={() => {this.setState({content: 'priority'})}}/>
                        <ListTile text={this.props.item['status'] === itemContext.STATUS.INCOMPLETE ? 'Mark as completed' : 'Mark as incomplete'} 
                            icon={<FaTasks/>} onSelect={this.statusHandler}/>
                        <ListTile text='Schedule' icon={<FaCalendarPlus/>} onSelect={() => {this.setState({content: 'schedule'})}}/>
                        <ListTile text='Remove schedule' icon={<FaCalendarMinus/>} onSelect={() => {this.setState({content: 'unschedule'})}}/>
                        <ListTile text='Reminder' icon={<FaBell/>} onSelect={() => {this.setState({content: hasSchedule ? 'alerts' : 'schedule'})}}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content:'delete'})}}/>
                    </Animation>
                </AnimatePresence>

                : incomplete ?
                <AnimatePresence key='main'>
                    <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                        <ListTile text='Open' icon={<FaExpandAlt/>} onSelect={this.openItem}/>
                        {<ListTile text='Edit' icon={<FaEdit/>} onSelect={this.editItem}/>}
                        <ListTile text='Priority' icon={<FaFlag/>} onSelect={() => {this.setState({content: 'priority'})}}/>
                        <ListTile text='Tags' icon={<FaTags/>} onSelect={() => {this.setState({content: 'tags'})}}/>
                        {/* <ListTile text={inFocus ? 'Remove from focus' : 'Add to focus'} icon={<FaEye/>} onSelect={() => {this.setState({content: 'focus'})}}/> */}
                        
                        <Line size='1'/>
                        <ListTile text='Plan for today' icon={<FaTasks/>} onSelect={this.setScheduleToday}/>
                        <ListTile text='Schedule' icon={<FaCalendarDay/>} onSelect={() => {this.setState({content: 'schedule'})}}/>
                        <ListTile text='Reminder' icon={<FaBell/>} onSelect={() => {this.setState({content: hasSchedule ? 'alerts' : 'schedule'})}}/>

                        <Line size='1'/>
                        <ListTile text='Shift item' icon={<FaExchangeAlt/>} onSelect={() => {this.setState({content: 'move'})}}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content:'delete'})}}/>
                    </Animation>
                </AnimatePresence>

                : <AnimatePresence key='main'>
                    <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                        <ListTile text='Open' icon={<FaExpandAlt/>} onSelect={this.openItem}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content:'delete'})}}/>
                    </Animation>
                </AnimatePresence>
                break

            default:
                content = 
                this.props.type === 'calendar' ? 
                <AnimatePresence key='main'>
                    <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                        <ListTile text='Open' icon={<FaExpandAlt/>} onSelect={this.openItem}/>
                        <ListTile text='Priority' icon={<FaFlag/>} onSelect={() => {this.setState({content: 'priority'})}}/>
                        <ListTile text={this.props.item['status'] === itemContext.STATUS.INCOMPLETE ? 'Mark as completed' : 'Mark as incomplete'} 
                            icon={<FaTasks/>} onSelect={this.statusHandler}/>

                        <ListTile text='Schedule' icon={<FaCalendarPlus/>} onSelect={() => {this.setState({content: 'schedule'})}}/>
                        <ListTile text='Remove schedule' icon={<FaCalendarMinus/>} onSelect={() => {this.setState({content: 'unschedule'})}}/>
                        <ListTile text='Reminder' icon={<FaBell/>} onSelect={() => {this.setState({content: hasSchedule ? 'alerts' : 'schedule'})}}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content:'delete'})}}/>
                    </Animation>
                </AnimatePresence>

                : incomplete ?
                <AnimatePresence key='default'>
                    <Animation key='default' boundingRect={this.state.boundingRect}>
                        <ListTile text='Open' icon={<FaExpandAlt/>} onSelect={this.openItem}/>
                        <ListTile text='Edit' icon={<FaEdit/>} onSelect={this.editItem}/>
                        <ListTile text='Priority' icon={<FaFlag/>} onSelect={() => {this.setState({content: 'priority'})}}/>
                        <ListTile text='Tags' icon={<FaTags/>} onSelect={() => {this.setState({content: 'tags'})}}/>
                        {/* <ListTile text={inFocus ? 'Remove from focus' : 'Add to focus'} icon={<FaEye/>} onSelect={() => {this.setState({content: 'focus'})}}/> */}
                        
                        <Line size='1'/>
                        <ListTile text='Plan for today' icon={<FaTasks/>} onSelect={this.setScheduleToday}/>
                        <ListTile text='Schedule' icon={<FaCalendarDay/>} onSelect={() => {this.setState({content: 'schedule'})}}/>
                        <ListTile text='Reminder' icon={<FaBell/>} onSelect={() => {this.setState({content: hasSchedule ? 'alerts' : 'schedule'})}}/>

                        <Line size='1'/>
                        <ListTile text='Shift item' icon={<FaExchangeAlt/>} onSelect={() => {this.setState({content: 'move'})}}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content:'delete'})}}/>
                    </Animation>
                </AnimatePresence> :
                <AnimatePresence key='default'>
                    <Animation key='default' boundingRect={this.state.boundingRect}>
                        <ListTile text='Open' icon={<FaExpandAlt/>} onSelect={this.openItem}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content:'delete'})}}/>
                    </Animation>
                </AnimatePresence> 
        };

        return(
            <ContextMenu>
                <Measure
                    bounds
                    onResize={contentRect => {
                        this.setState({ boundingRect: contentRect.bounds })
                    }}
                >
                    {({ measureRef }) => (
                        <div ref={measureRef}>{content}</div>
                    )}
                </Measure>
            </ContextMenu>
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        sessionId: state.content.sessionId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateItem: (item, data, uid, sessionId) => dispatch(actionCreators.updateItem(item, data, uid, sessionId)),
        updateItemSchedule: (alerts, item, data, uid, sessionId) => dispatch(actionCreators.updateItemSchedule(alerts, item, data, uid, sessionId)),
        updateItemStatus: (item, data, uid, sessionId) => dispatch(actionCreators.updateItemStatus(item, data, uid, sessionId)),
        deleteItem: (item, data, uid) => dispatch(actionCreators.deleteItem(item, data, uid)),
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID)),
        shiftItem: (data, item, parents, parentIndex, targetSectionID, targetPageID, userId, sessionId) => dispatch(actionCreators.shiftItem(data, item, parents, parentIndex, targetSectionID, targetPageID, userId, sessionId)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemMenu);